<section id="services" class="section-padding">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h2>HİZMET VERDİĞİMİZ SEKTÖRLER</h2>
        <div class="services-table clearfix">
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector1"></i>
            </div>
            <div>
              <span class="fwb">OTOMOTİV İTHALAT ve</span>
              <span>ÜRETİCİLERİ</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector2"></i>
            </div>
            <div>
              <span class="fwb">OTOMOBİL</span>
              <span>MARKALARI</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector3"></i>
            </div>
            <div>
              <span class="fwb">OTOMOBİL</span>
              <span>BAYİLERİ</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector4"></i>
            </div>
            <div>
              <span class="fwb">OTOMOBİL</span>
              <span>GALERİLERİ</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector5"></i>
            </div>
            <div>
              <span class="fwb">2.EL ARAÇ ALIM-SATIM</span>
              <span>ŞİRKETLERİ</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector6"></i>
            </div>
            <div>
              <span class="fwb">SİGORTA</span>
              <span>ŞİRKETLERİ</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector7"></i>
            </div>
            <div>
              <span class="fwb">BANKA FİNANS </span>
              <span>KURULUŞLARI</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector8"></i>
            </div>
            <div>
              <span class="fwb">FİLO ve KİRALAMA</span>
              <span>ŞİRKETLERİ</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector9"></i>
            </div>
            <div>
              <span class="fwb">İNTERNET</span>
              <span>İLAN SİTELERİ</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector10"></i>
            </div>
            <div>
              <span class="fwb">TEKNOLOJİ ve</span>
              <span>TELEKOMÜNİKASYON</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector11"></i>
            </div>
            <div>
              <span class="fwb">PAZAR ARAŞTIRMA </span>
              <span>ŞİRKETLERİ</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector12"></i>
            </div>
            <div>
              <span class="fwb">YEDEK PARÇA ve SATIŞ SONRASI</span>
              <span>ŞİRKETLERİ</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector13"></i>
            </div>
            <div>
              <span class="fwb">DANIŞMANLIK</span>
              <span>ŞİRKETLERİ</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector14"></i>
            </div>
            <div>
              <span class="fwb">MEDYA</span>
              <span>ŞİRKETLERİ</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper">
              <i class="sprite icon-sector15"></i>
            </div>
            <div>
              <span class="fwb">VARLIK YÖNETİMİ ve FAKTORİNG</span>
              <span>ŞİRKETLERİ</span>
            </div>
          </div>
          <div class="services-item">
            <div class="icon-wrapper" style="font-size: 44px;">
              <i class="fa fa-user"></i>
            </div>
            <div>
              <span class="fwb">TÜKETİCİLER</span>
              <span>BİREYSEL KULLANIM</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br /><br />
    <div class="row s-footer">
      <div class="col-md-12 tac">
        <a [routerLink]="['/contact']" class="btn btn-primary btn-m">Detaylı Bilgi için İletişime Geçin</a>
      </div>
    </div>
  </div>
</section>